import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {OphButtonModule} from 'src/app/shared/design/oph-button/oph-button.module';

@Component({
  selector: 'projects-task-subtask-button-footer',
  standalone: true,
  imports: [OphButtonModule],
  templateUrl: './projects-task-subtask-button-footer.component.html',
  styleUrl: './projects-task-subtask-button-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectsTaskSubtaskButtonFooterComponent {
  @Input() disabled: boolean;
  @Input() loadingSave: boolean;

  @Output() newSubtask = new EventEmitter<void>();
  @Output() finish = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();
}
